var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countdownText)?_c('div',[_c('span',{staticStyle:{"font-size":"10px"}},[_vm._v("仅剩 ")]),_c('span',[_vm._v(_vm._s(_vm.countdownText))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }